import { render, staticRenderFns } from "./Satgas.vue?vue&type=template&id=52c138c7"
import script from "./Satgas.vue?vue&type=script&lang=js"
export * from "./Satgas.vue?vue&type=script&lang=js"
import style0 from "./Satgas.vue?vue&type=style&index=0&id=52c138c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports